import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { OrganisationSearchDispatcher } from "./Variable";

export interface OrganisationSearchStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class OrganisationSearchStatic extends BaseStore<OrganisationSearchStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(OrganisationSearchDispatcher, (actionData) => this.onOrganisationSearchStoreResponse(actionData));
    }

    public getLastResult(): OrganisationSearchStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): OrganisationSearchStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onOrganisationSearchStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}